@if (vm.fixture) {
    <div
        class="linked-option-group-container option-group-container"
        msParticipantOptionRenderer
        [fixture]="vm.fixture"
        [optionPickClass]="'.linked-option-pick > div'"
        (rerender)="rendererChange($event)">
        @for (participant of vm.participants; track participant.id; let i = $index) {
            <div [ngClass]="!showOption(i) ? 'linked-option option option-hidden' : 'linked-option option'">
                @if (vm.options[participant.id]; as option) {
                    <ms-fixture-pick
                        class="linked-option-pick"
                        trackingSource="RacePage/Antepost"
                        [fixture]="vm.fixture"
                        [participant]="participant"
                        [parentLinkedEventId]="parentLinkedEventId"
                        [option]="option">
                        [title]="participant.name.value"
                        <div class="name">{{ participant.name.value }}</div>
                        @if (!isLocked(option, participant)) {
                            <div class="value option-value">{{ option.price | msExternalPriceFormatter }}</div>
                        } @else {
                            <div class="fixture-pick-odds result-odds lock">
                                <vn-icon
                                    class="option-group-lock-icon"
                                    [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'"
                                    [size]="isEpcotEnabled ? '16' : '14'" />
                            </div>
                        }
                        <!-- TODO: to be implemented with promo initiative -->
                        <!-- <ms-promotion-badge class="no-title" *ngIf="crmPromotedOptionIdsMap[option.id]"></ms-promotion-badge> -->
                    </ms-fixture-pick>
                }
            </div>
        }
        <ng-container *msShowInEpcot="false">
            @if (threshold && vm.fixture && threshold < vm.fixture.participants.length) {
                <div class="more" (click)="expand()">
                    @if (more) {
                        <span class="collapsed"
                            >{{ this.sitecore.event.ShowMore }}
                            <vn-icon size="12" name="theme-down" />
                        </span>
                    } @else {
                        <span class="expanded"
                            >{{ this.sitecore.event.ShowLess }}
                            <vn-icon size="12" name="theme-up" />
                        </span>
                    }
                </div>
            }
        </ng-container>
    </div>
}
<ng-container *msShowInEpcot="true">
    @if (threshold && vm.fixture && threshold < vm.fixture.participants.length) {
        <div class="show-more-less-button" [ngClass]="{ expanded: more }" (click)="expand()">
            {{ more ? this.sitecore.event.ShowLess : this.sitecore.event.ShowMore }}
            <vn-icon name="theme-right" size="12" />
        </div>
    }
</ng-container>
